import { useRef, useEffect, type ReactNode, JSX } from "react";

import { Box } from "@mui/material";

import { scrollContainer } from "./infoBar.helper";

function HorizontalScrollWrapper({ children }: { children: ReactNode }): JSX.Element {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return undefined;

    const handleWheel = (e: WheelEvent): void => {
      if (!el) return;
      if (e.deltaY === 0) return;
      e.preventDefault();

      const delta = Number(e.deltaY);
      const currentScroll = Number(el.scrollLeft);
      el.scrollLeft = currentScroll + delta;
    };

    el.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      el.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return (
    <Box ref={scrollRef} sx={scrollContainer}>
      {children}
    </Box>
  );
}

export default HorizontalScrollWrapper;
